import event from 'store/event';

export function useEvent() {
  return event;
}
